<template>
  <div id="center">
    <div class="d-flex pt-2 pl-2 mar">
      <span>
        <icon name="chart-pie" class="text-icon"></icon>
      </span>
      <div class="d-flex">
        <span class="fs-xl text mx-2">数据总览</span>
      </div>
    </div>
    <div class="up">
      <div class="bg-color-black item" v-for="item in titleItem" :key="item.title">
        <p class="tits colorBlue fw-b">{{ item.title }}</p>
        <div class="numbers">{{item.number}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import CenterChart from '@/components/echart/center/centerChartRate'

  export default {
    props: ['inquiry2', 'mall'],
    data() {
      return {
        titleItem: [{
            title: '咨询总量',
            number: 0
          },
          {
            title: '咨询费用总额(元)',
            number: 0
          },
          {
            title: '商城消费总额(元)',
            number: 0
          },
          {
            title: '知识付费总额(元)',
            number: 0
          },
        ],

      }
    },
    components: {
      CenterChart
    },
    watch: {
      inquiry2: {
        handler(n) {
          this.titleItem[0].number = n.total_count ? n.total_count - 0 : 0
          this.titleItem[1].number = n.total_price ? n.total_price - 0 : 0
        },
        immediate: true,
        deep: true
      },
      mall: {
        handler(n) {
          this.titleItem[2].number = n.total_price ? n.total_price : 0
        },
        immediate: true,
        deep: true
      },
    }
  }
</script>

<style lang="scss" scoped>
  #center {
    display: flex;
    flex-direction: column;

    .mar {
      margin-top: 18px;
      margin-left: 10px;
    }

    .up {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      padding: 0 13px;
      margin-bottom: 20px;

      .item {
        border-radius: 6px;
        padding-top: 8px;
        margin-top: 8px;
        width: 24%;

       
        .tits{
          text-align: center;
        }

        .numbers {
          color: #7ec699;
          font-size: 26px;
          font-weight: 700;
          text-align: center;
          padding: 12px 0;
        }
      }
    }


  }
</style>